













import { Component, Vue, Watch } from "vue-property-decorator";
import Banner from "@/components/Banner/Banner";
import ProductListContainer from '@/components/ProductListContainer/ProductListContainer';
import CatNav from '@/components/CatNav/CatNav';
import { getCategoryTrail } from '@/api/categories';

@Component({
  components: {
    Banner,
    ProductListContainer,
    CatNav
  }
})
export default class Categories extends Vue {
  initCount = 0
  categoryId = ''
  notFound = false
  @Watch('$route', { immediate: true, deep: true })
    async onViewChange() {
      const path = this.$route.path
      const trail = await getCategoryTrail(this.$route.params.cat.split('/'))
      // Another navigation has started meanwhile
      if (path !== this.$route.path) return
      this.categoryId = trail ? trail[trail.length - 1].id : ''
      this.notFound = !trail
    }
}
